import { getInputCombination, getKeyboardKey, InputCombination, joinString } from 'outpost';
import { CSSProperties, useEffect } from 'outpost/preact';

export type ButtonProps = {
    style?: CSSProperties;
    label: string;
    onClick: () => void;
    disabled?: boolean;
    shortcut?: InputCombination | InputCombination[];
    tooltip?: string;
    hidden?: boolean;
};

export function Button(props: ButtonProps) {
    let { label, disabled, onClick, shortcut, tooltip, hidden } = props;
    let style = {
        display: hidden ? 'none' : undefined,
        ...props.style
    };
    let shortcuts = joinString(shortcut, ',');

    useEffect(() => {
        let list = shortcuts.split(',');

        let onKeyDown = (evt: KeyboardEvent) => {
            let pressedCombination = getInputCombination(getKeyboardKey(evt), 'down', evt);

            if (!disabled && list.some(combination => pressedCombination === combination)) {
                onClick();
            }
        };

        document.addEventListener('keydown', onKeyDown);

        return () => document.removeEventListener('keydown', onKeyDown);
    }, [shortcuts, onClick, disabled]);

    return (
        <button style={style} onClick={onClick} disabled={disabled} title={tooltip} >
            {label}
        </button>
    );
}